<template>
    <VContainer>
        <div class="text-left">
            <h1><VIcon icon="mdi-briefcase"></VIcon> Experience</h1>
            <VTimeline align="start" side="end">
                <VTimelineItem v-for="(experience, index) in workExperiences" :key="index" :dot-color="index % 2 === 0 ? 'teal-darken-1' : 'blue-darken-1'" icon="mdi-briefcase-outline">
                    <VCard>
                        <VCardTitle class="text-h6" :class="index % 2 === 0 ? 'bg-teal-lighten-4' : 'bg-blue-lighten-4'">
                            {{ experience.title }}
                        </VCardTitle>
                        <VCardText class="bg-white">
                            <p class="mt-2 font-weight-bold">
                                {{ experience.subtitle }}
                            </p>
                            <p class="mt-2">
                                {{ experience.description }}
                            </p>
                            <p class="mt-2">
                                <VChip v-for="(skill, skillIndex) in experience.skills" :key="skillIndex" class="mr-2 mb-2" color="indigo-lighten-1" label>
                                    <VIcon v-if="skill.icon" :icon="skill.icon"></VIcon><span class="ml-1">{{ skill.name }}</span>
                                </VChip>
                            </p>
                        </VCardText>
                    </VCard>
                </VTimelineItem>
            </VTimeline>
        </div>
    </VContainer>
</template>

<script>
export default {
    name: "ExperienceOverview",
    data() {
        return {
            workExperiences: [
                {
                    "title": "IT Lead Application Developer @ Siemens Digital Industry Software, Inc.",
                    "subtitle": "Costa Mesa, CA | April 2017 - Present",
                    "description": "Integrated an AI powered chatbot in the application that automated frequently asked questions and also answered questions regarding tickets. Developed an AI Powered feature that helped users find duplicate tickets. Significantly improved a Partner Team’s ability to correctly identify first-line support sources and streamline overall support operations. Effectively led an Agile team as a SCRUM Master. Help and mentor other team members. Integrated Elastic Database for Search functionality. Design and maintain RESTful API using Spring Boot that’s utilized by different groups internally to consume and update data. Developed user interfaces using VueJS that improved load times and user engagement. Develop and maintain a TFS interface between the internal ticketing system and TFS instance to help R&D groups manage their tickets. Utilize Github Development workflow and Github Actions in our CI/CD pipeline.",
                    "skills": [
                        {
                            name: "Agile Development | SCRUM",
                            icon: "mdi-chart-timeline-variant-shimmer"
                        },
                        {
                            name: "Version Control (Mercurial, GitHub)",
                            icon: "mdi-source-branch"
                        },
                        {
                            name: "Web Responsive Design",
                            icon: "mdi-responsive"
                        },
                        {
                            name: "RESTful APIs",
                            icon: "mdi-api"
                        },
                        {
                            name: "Java",
                            icon: "mdi-language-java"
                        },
                        {
                            name: "Spring Boot",
                            icon: "mdi-leaf"
                        },
                        {
                            name: "VueJS",
                            icon: "mdi-vuejs"
                        },
                        {
                            name: "HTML",
                            icon: "mdi-language-html5"
                        },
                        {
                            name: "CSS",
                            icon: "mdi-language-css3"
                        },
                        {
                            name: "JavaScript",
                            icon: "mdi-language-javascript"
                        },
                        {
                            name: "Relational Databases (Ingres, PostgreSQL)",
                            icon: "mdi-database"
                        },
                        {
                            name: "Github",
                            icon: "mdi-github"
                        },
                        {
                            name: "Github Actions",
                            icon: "mdi-github"
                        },
                        {
                            name: "Continuous Integration/Continuous Deployment (CI/CD)",
                            icon: "mdi-cogs"
                        },
                        {
                            name: "Code Review",
                            icon: "mdi-eye-check"
                        },
                        {
                            name: "Github Packages",
                            icon: "mdi-github"
                        },
                        {
                            name: "Amazon S3",
                            icon: "mdi-aws"
                        },
                        {
                            name: "AWS CloudFront",
                            icon: "mdi-aws"
                        },
                        {
                            name: "Amazon Route53",
                            icon: "mdi-aws"
                        }
                    ]
                },
                {
                    "title": "Software Engineer @ CompuGroup Medical USA",
                    "subtitle": "Irvine, CA | May 2016 - April 2017",
                    "description": "Maintain and develop enhancements for EHR product - an Electronic Health Record Software. Continuously work with the QA team to discuss and provide solutions to QA found software issues. Worked on integrating other products to our EHR Software using web services. Discussed solutions with the team during Sprint meetings.",
                    "skills": [
                        {
                            name: "Agile Development | SCRUM",
                            icon: "mdi-chart-timeline-variant-shimmer"
                        },
                        {
                            name: "Jira",
                            icon: "mdi-jira"
                        },
                        {
                            name: "PHP",
                            icon: "mdi-language-php"
                        },
                        {
                            name: "JavaScript",
                            icon: "mdi-language-javascript"
                        },
                        {
                            name: "CSS",
                            icon: "mdi-language-css3"
                        },
                        {
                            name: "HTML",
                            icon: "mdi-language-html5"
                        },
                        {
                            name: "Angular2",
                            icon: "mdi-angular"
                        },
                        {
                            name: "MySQL",
                            icon: "mdi-database"
                        }
                     ]
                },
                {
                    "title": "IT Application Developer (Intermediate) @ Siemens Digital Industry Software, Inc.",
                    "subtitle": "Cypress, CA | June 2010 - May 2016",
                    "description": "Developed and maintained internal web applications. Developed an interface where the customer sends in XML requests. Created test plans and other documents. Automated some server and database backup processes using korn shell and perl. Started a modified Bootstrap UI project that allows our group to utilize it for Siemens UI guidelines.",
                    "skills": [
                        {
                            name: "PHP",
                            icon: "mdi-language-php"
                        },
                        {
                            name: "JavaScript",
                            icon: "mdi-language-javascript"
                        },
                        {
                            name: "jQuery",
                            icon: "mdi-jquery"
                        },
                        {
                            name: "CSS",
                            icon: "mdi-language-css3"
                        },
                        {
                            name: "HTML",
                            icon: "mdi-language-html5"
                        },
                        {
                            name: "Ingres Database",
                            icon: "mdi-database"
                        },
                        {
                            name: "Waterfall Development",
                            icon: "mdi-water"
                        }
                    ]
                },
                {
                    "title": "Encounter Data Coordinator @ Accountable Healthcare IPA",
                    "subtitle": "Signal Hill, CA | September 2006 - May 2010",
                    "description": "Entered encounter data into the system. Combine provider checks and letters in the mailing envelopes.",
                    "skills": [
                        {
                            name: "Data Entry",
                            icon: "mdi-keyboard"
                        },
                        {
                            name: "Attention to Detail",
                            icon: "mdi-eye-check"
                        }
                     ]
                }
            ]
        };
    },
    mounted() {
        document.title = 'PEREY | ME - Experience';
    },
}
</script>